import styles from "./PPTPollsPage.module.css";
import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {PollApiCalls} from "../../apis/PollApiCalls";
import {ResponseApiCalls} from "../../apis/ResponseApiCalls";
import Skeleton from "react-loading-skeleton";
import PPTSlides from "./PPTSlides";


export default function SlideTemplate({ }) {
    const {getPublishedPollDataFromKey, } = PollApiCalls();
    const {getResponsesDataByPoll} = ResponseApiCalls();
    let {pollCode, pollKey, shareMode} = useParams();
    const [dataReady, setDataReady] = useState(false);
    const [poll, setPoll] = useState({});
    const [questions, setQuestions] = useState([]);
    const [liveResponsesData, setLiveResponsesData] = useState([]);




    useEffect(() => {
        let promise1 = getPublishedPollDataFromKey(pollKey, pollCode).then(res => {
            let {poll={}, questions=[]} = res;
            questions = questions.sort((q1, q2) => q1.serialNo - q2.serialNo);
            setQuestions(questions);
            setPoll(poll);
        });

        let promise2 = getResponsesDataByPoll(pollKey, pollCode).then(res => {
            setLiveResponsesData(res);
        });

        Promise.all([promise1, promise2]).finally(() => {
            setDataReady(true);
        });


    }, []);




    if (!dataReady) {
        return (
            <div className={`${styles.canvas}`}>
                <Skeleton borderRadius={10} inline={true} width={"100%"} height={"100%"}/>
            </div>
        );
    }


    return (
        <PPTSlides
            poll={poll}
            questions={questions}
            shareMode={shareMode}
            liveResponsesData={liveResponsesData}
        />
    );
}